import { GridWrapper } from '../wrapper'
import { styled } from '@mui/material/styles'

export const GridPartialScreen = styled(GridWrapper)(() => ({
  width: '100%',
  alignItems: 'center',
  justifyContent: 'space-around',
}))
